import(/* webpackMode: "eager" */ "/vercel/path0/src/app/referral/[code]/page.tsx");
